module.exports = __webpack_public_path__ + "static/media/asc-arrow.ece87277.svg";